<template>
    <div>
        <!-- Modèle -->
        <div v-if="hasModelOptions" class="form-group mb-2 mt-2 d-flex align-items-center gap-2">
            <label for="select-model" class="form-label mb-0 text-nowrap pr-1" style="font-size: 14px;">Traduction</label>
            <select id="select-model" class="form-control" :value="selectedModel" :disabled="isLoading"
                @change="onModelChange">
                <option v-for="m in modelOptions" :key="m.value" :value="m.value">{{ m.label }}</option>
            </select>
        </div>
        <div v-else-if="!isLoadingModels" class="o-alert o-alert--error mb-0" role="alert">
            <div class="o-alert__icon">
                <svg class="svg-icon svg-circle-cross" aria-hidden="true" focusable="false">
                    <use xlink:href="/wp-content/themes/ans/design-system/svg-icons/icon-sprite.svg#circle-cross"></use>
                </svg>
            </div>
            <h2 class="o-alert__title">{{ config.input.messages.noModelAlertTitle }}</h2>
            <p>{{ config.input.messages.noModelAlertBody }}</p>
        </div>
    </div>
</template>

<script>
import config from '../config/translator.config.js';

/**
 * Composant de saisie des paramètres de traduction.
 * Expose le choix du modèle via des props synchronisées (.sync).
 * La liste des modèles est chargée une seule fois par le parent (TranslatorInput)
 * et transmise en props, afin d'éviter un appel redondant au middleware.
 *
 * @prop  {Boolean} isLoading      - Désactive les contrôles pendant une traduction.
 * @prop  {String}  selectedModel  - Identifiant du modèle sélectionné (.sync).
 * @prop  {Array}   modelOptions   - Liste des modèles disponibles { value, label }.
 * @prop  {Boolean} isLoadingModels - Vrai pendant le chargement initial des modèles.
 * @emits update:selectedModel     - Nouveau modèle sélectionné.
 */
export default {
    name: 'TranslatorParameterInput',
    props: {
        /** Désactive les contrôles pendant le chargement. */
        isLoading: {
            type: Boolean,
            default: false
        },
        /** Modèle de traduction actuellement sélectionné. */
        selectedModel: {
            type: String,
            default: ''
        },
        /** Liste des modèles à afficher dans le select. */
        modelOptions: {
            type: Array,
            default: () => []
        },
        /** Vrai pendant le chargement initial des modèles, pour éviter l'affichage prématuré de l'erreur. */
        isLoadingModels: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return { config }
    },
    computed: {
        hasModelOptions() {
            return this.modelOptions.length > 0
        }
    },
    methods: {
        /**
         * Propage le nouveau modèle sélectionné depuis le <select>.
         * @param {Event} event - Événement change natif du select.
         */
        onModelChange(event) {
            this.$emit('update:selectedModel', event.target.value)
        }
    }
}
</script>
